module.exports = __webpack_public_path__ + "img/header-bg.3cf83284.jpg";